import * as React from 'react'

import withCms from 'cms/with-cms'
import withLayout from 'cms/with-layout'

import type { Util as FormUtil } from '@grandvisionhq/forms'
import type { NextPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { InitialProps, Page, Props as ReturnsProps } from '@grandvisionhq/www-next/pages/returns'

import { isOrderNumber } from '../../util/form-validation'

import '@grandvisionhq/fun-returns/dist/index.css'

type Props = ReturnsProps & {
  isOrderNumberValid: FormUtil.validations.Validator
}

const ReturnsPage: NextPage<Props, InitialProps> = (props) => (
  <Page {...props} isOrderNumberValid={isOrderNumber} />
)

ReturnsPage.getInitialProps = Page.getInitialProps

export default compose(withCms(), withLayout())(ReturnsPage)
